<template>
  <div class="credit-card">

    <div class="default-card"
         v-if="card.default">
      {{$t('client.matters.matter_page.contact.payments.default')}}
    </div>

    <div class="card-brand">
      {{card.card_brand}}
    </div>

    <VSvgIcon class="card-logo"
              tag="misc" size="28" viewBox="0 0 36 24"
              :icon="card.card_brand.toLowerCase()"/>

    <div class="card-number">
      **** {{card.last_4}}
    </div>

    <div class="card-expiry">
      {{cardExpiryDate(card.exp_month, card.exp_year)}}
    </div>

    <v-menu v-model="showMenu"
            content-class="credit-card-dropdown-menu"
            offset-y
            v-if="canEditCard">
      <template v-slot:activator="{on, attrs}">
        <v-icon class="menu-icon"
                v-bind="attrs"
                v-on="on">
          icon-dots-three-vertical
        </v-icon>
      </template>
      <v-list>
        <v-list-item v-for="actionItem in actionItems"
                     :key="actionItem.title"
                     @click="cardAction(actionItem.action, card.id)">
          <v-list-item-title>
            {{actionItem.title}}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <div class="card-creator">
      {{$t('client.matters.matter_page.contact.created_by', {name: card.staff_name})}}
    </div>

  </div>
</template>

<script>
  import {VSvgIcon} from '@/modules/common/components';
  import {numberUtil} from '@/modules/common/utils'

  export default {
    name: "CreditCard",
    components: { VSvgIcon },
    props: {
      card: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        showMenu: false,
        actionItems: [
          { title: this.$t('client.matters.matter_page.contact.payments.remove'), action: 'remove' },
          { title: this.$t('client.matters.matter_page.contact.payments.set_default'), action: 'set_default' }
        ]
      }
    },
    computed: {
      canEditCard() {
        return this.$hasPermission('can_refund');
      }
    },
    methods: {
      cardExpiryDate(month, year) {
        return `${numberUtil.addLeadingZero(month)}/${numberUtil.addLeadingZero(year % 100)}`;
      },
      cardAction(action, id) {
        this.$frontageApi.send('matter_action', {action: 'credit_card_action', data: {action: action, id: id}});
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import '@/assets/scss/abstract/_i18n-mixins';

  .credit-card {
    border: solid 1px $grey-color-2;
    border-radius: 4px;
    margin: 0 -10px 10px -10px;
    padding: 10px 15px;

    .default-card {
      font-size: 9px;
      color: $white-color-1;
      background-color: $brand_secondary_color;
      width: 48px;
      height: 16px;
      text-align: center;
      padding: 1px 0;
      border-radius: 4px;
      position: relative;
      @include i-position-mirror(right, -75%);
      top: -18px;
      margin-bottom: -16px;
    }

    .card-brand {
      font-weight: 600;
      padding-bottom: 3px;
    }

    .card-logo {
      @include i-margin-mirror(0, 8px);
      top: 9px;
      position: relative;
      margin-top: -7px;
    }

    .card-number, .card-expiry {
      display: inline-block;
      color: $grey-color-6;
      @include i-padding-mirror(0, 8px);
    }

    .menu-icon {
      font-size: 18px;
      color: $grey-color-5;
      @include i-float(right);
      top: 6px;
      @include i-margin-mirror(0, -10px);
    }

    .card-creator {
      padding-top: 10px;
      font-size: 10px;
      color: $grey-color-6;
    }
  }

  .credit-card-dropdown-menu {
    z-index: 50 !important;

    .v-list-item {
      height: 35px;
      width: 150px;
      min-height: auto;

      &__title {
        font-family: var(--primary-font-family);
        font-weight: 500;
        font-size: 12px;
        color: $blue-color-2;
      }
    }
  }
</style>
